/**
 * 不良画像を拡大表示するコンポーネント
 */
import React, {
  useRef,
  useEffect,
  RefObject,
  useState,
  createRef,
} from "react";
import { useWindowSize } from "../../hooks/useWindowSize";
import Carousel from "react-material-ui-carousel";
import "./DefectsPreview.css";
import { DefectsImageProp } from "../../redux/defectsSlice";

interface DefectsPreviewProps {
  images: DefectsImageProp[];
  index: number;
}

const DefectsConfirm: React.FC<DefectsPreviewProps> = (props) => {
  const [windowWidth, windowHeight] = useWindowSize();

  // カルーセルに配置するCanvasを作成
  const [previewImages, setPreviewImages] = useState<JSX.Element[]>([]);
  const canvasRefs = useRef<RefObject<HTMLCanvasElement>[]>([]);
  const createCanvas = () => {
    const imageWidth = windowWidth - 240;
    const imageHeight = windowHeight - 180;
    const newImages = props.images.map((element, index: number) => {
      canvasRefs.current[index] = createRef<HTMLCanvasElement>();
      return (
        <div className="defects-preview-container">
          <div className="defects-comfirm-preview-button"></div>
          <canvas
            width={imageWidth}
            height={imageHeight}
            className="defects-comfirm-preview-canvas"
            ref={canvasRefs.current[index]}
            style={{
              width: imageWidth + "px",
              height: imageHeight + "px",
            }}
          ></canvas>
          <div className="defects-comfirm-preview-button"></div>
        </div>
      );
    });
    setPreviewImages(newImages);
  };
  // Canvasにイメージをセット
  const setImages = () => {
    const sortedImages = [
      ...props.images.slice(props.index),
      ...props.images.slice(0, props.index),
    ];
    canvasRefs.current.forEach((element, index) => {
      if (element.current != null) {
        let ctx = element.current.getContext("2d");
        let img = new Image();
        img.src = sortedImages[index].images;
        img.onload = function () {
          if (ctx != null) {
            const canvasAspect = ctx.canvas.width / ctx.canvas.height;
            const imgAspect = img.width / img.height;
            let left, top, width, height;
            if (imgAspect >= canvasAspect) {
              // 画像が横長
              left = 0;
              width = ctx.canvas.width;
              height = ctx.canvas.width / imgAspect;
              top = (ctx.canvas.height - height) / 2;
            } else {
              // 画像が縦長
              top = 0;
              height = ctx.canvas.height;
              width = ctx.canvas.height * imgAspect;
              left = (ctx.canvas.width - width) / 2;
            }
            ctx.drawImage(
              img,
              0,
              0,
              img.width,
              img.height,
              left,
              top,
              width,
              height
            );
          }
        };
      }
    });
  };

  // Canvasを再作成
  useEffect(() => {
    createCanvas();
  }, [props.images, windowWidth, windowHeight]);

  // Canvasにイメージをセット
  useEffect(() => {
    setTimeout(setImages, 0);
  }, [previewImages]);

  return (
    <div className="defect-preview">
      <Carousel
        index={props.index}
        autoPlay={false}
        navButtonsAlwaysVisible={true}
      >
        {previewImages}
      </Carousel>
    </div>
  );
};

export default DefectsConfirm;
